module.exports = __webpack_public_path__ + "static/media/promo_1.82288032.svg";